import './globalSettingCtrl';
import './style.scss';
